import { render, staticRenderFns } from "./TL.vue?vue&type=template&id=538e13fe&scoped=true&"
import script from "./TL.vue?vue&type=script&lang=js&"
export * from "./TL.vue?vue&type=script&lang=js&"
import style0 from "./TL.vue?vue&type=style&index=0&id=538e13fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e13fe",
  null
  
)

export default component.exports